import Api from './Account.api';
import { accountConstants } from './Account.constants';
import { map as _map, forEach as _forEach, filter as _filter, isEmpty as _isEmpty } from 'lodash-es';
import { getActiveNickNameIds, hiddenChannels } from 'utilities/utilities_exports';

const account = new Api('services', 'account');
const order = new Api('services', 'order');
const Inventory = new Api('services', 'inventory');

// --- Error Handller

export const getAccountData = () => {
  let apiData = {};
  return async dispatch => {
    dispatch({ type: accountConstants.GET_NICK_NAME_STORES_REQUEST });
    try {
      apiData = await account.getAccountData();
      if (apiData && apiData.hasError) {
        throw new Error();
      } else {
        const { data } = apiData;
        const filteredNickNames =
          _filter(data?.nicknames, n => {
            const spl = n?.id?.split('-')?.[0] || '';
            return !hiddenChannels.includes(spl);
          }) || [];
        const filteredSOurceNickNames =
          _filter(data?.nicknames, n => {
            const spl = n?.id?.split('-')?.[0] || '';
            return !hiddenChannels.includes(spl) && !_isEmpty(n?.sourceChannelName);
          }) || [];
        dispatch({
          type: accountConstants.GET_NICK_NAME_STORES_SUCCESS,
          payload: {
            nicknames: filteredNickNames,
            sourceNicknames: filteredSOurceNickNames,
            list: _map(filteredNickNames, name => name?.id) || [],
            activeList: getActiveNickNameIds(filteredNickNames),
            nickNamesMap: getNickNameMap(filteredNickNames)
          }
        });
      }
    } catch (error) {
      dispatch({ type: accountConstants.GET_NICK_NAME_STORES_FAILED });
    }
  };
};

export const getTopSoldStores = queryParams => {
  let apiData = {};
  return async dispatch => {
    dispatch({ type: accountConstants.GET_TOP_SOLD_STORES_REQUEST });
    try {
      apiData = await order.getTopSoldStores(queryParams);
      if (apiData && apiData.hasError) {
        throw new Error();
      } else {
        dispatch({ type: accountConstants.GET_TOP_SOLD_STORES_SUCCESS, payload: apiData });
      }
    } catch (error) {
      dispatch({ type: accountConstants.GET_TOP_SOLD_STORES_FAILED });
    }
  };
};

export const getTopSoldSellerSKU = queryParams => {
  return async dispatch => {
    dispatch({ type: accountConstants.GET_TOP_SOLD_SKU_REQUEST });
    try {
      let apiData = await Inventory.getTopSoldSellerSKU(queryParams);
      if (apiData && apiData.hasError) {
        throw new Error();
      } else {
        dispatch({ type: accountConstants.GET_TOP_SOLD_SKU_SUCCESS, payload: apiData });
      }
    } catch (error) {
      dispatch({ type: accountConstants.GET_TOP_SOLD_SKU_FAILED });
    }
  };
};

export const initiateChannel = (channel, payload) => {
  let apiData = {};
  let errorObj = {};
  return async dispatch => {
    try {
      apiData = await account.initiateChannel(channel, payload);
      if (apiData && apiData?.hasError) {
        throw new Error();
      } else {
        return apiData;
      }
    } catch (error) {
      return errorObj;
    }
  };
};

export const getLinkedWMSData = () => {
  let apiData = {};
  return async dispatch => {
    dispatch({ type: accountConstants.GET_LINKED_WAREHOUSE_REQUEST });
    try {
      apiData = await account.getLinkedWMSData();
      if (apiData && apiData.hasError) {
        throw new Error();
      } else {
        const { data } = apiData;
        dispatch({
          type: accountConstants.GET_LINKED_WAREHOUSE_SUCCESS,
          payload: {
            warehouseNameMap: getWarehouseNameMap(data),
            warehouseList: getWarehouseList(data),
            warehouseChannels: data?.data
          }
        });
      }
    } catch (error) {
      dispatch({ type: accountConstants.GET_LINKED_WAREHOUSE_FAILED });
    }
  };
};

const getWarehouseNameMap = dataResponse => {
  let warehouseNameMap = {};
  const responseData = dataResponse?.data;
  for (let index in responseData) {
    let warehouseObj = responseData[index];
    warehouseNameMap[warehouseObj?.id] = warehouseObj?.id?.split('-')[0] + '-' + warehouseObj?.value;
  }
  return warehouseNameMap;
};

const getWarehouseList = dataResponse => {
  let warehouseIDList = [];
  const responseData = dataResponse?.data;
  for (let index in responseData) {
    let warehouseObj = responseData[index];
    if (!warehouseIDList.includes(warehouseObj?.id)) {
      warehouseIDList?.push(warehouseObj?.id);
    }
  }
  return warehouseIDList;
};

export const callDataMoatAPI = request => {
  let apiData = {};
  let errorObj = {};
  try {
    apiData = account.callDataMoatAPI(`dataMoat/login`, request);
    if (apiData && apiData?.hasError) {
      errorObj['hasError'] = apiData?.hasError;
      errorObj['success'] = false;
      errorObj['errorMessage'] = apiData?.error;
      throw new Error();
    } else {
      return apiData;
    }
  } catch (error) {
    return errorObj;
  }
};

export const getDataMoatRiskResponse = (userIP, ati, time, userID) => {
  let queryParam = 'ati=' + ati + '&userIP=' + userIP + '&time=' + time + '&userID=' + userID;
  let errorObj = {};
  try {
    return account.getDataMoatRiskResponse(queryParam);
  } catch (error) {
    return errorObj;
  }
};

const getNickNameMap = nickNames => {
  let nickNameObj = {};
  _forEach(nickNames, nickName => {
    let channel = nickName?.id?.split('-')?.[0];
    nickNameObj[channel + '-' + nickName?.value] = nickName?.id;
  });
  return nickNameObj;
};

export const getCalenderEvents = () => {
  let apiData = {};
  return async dispatch => {
    dispatch({ type: accountConstants.GET_CALENDAR_EVENTS_REQUEST });
    try {
      apiData = await account.getCalenderEvents();
      if (apiData && apiData.hasError) {
        throw new Error();
      } else {
        dispatch({ type: accountConstants.GET_CALENDAR_EVENTS_SUCESSS, payload: apiData?.data });
      }
    } catch (error) {
      dispatch({ type: accountConstants.GET_CALENDAR_EVENTS_FAILED });
    }
  };
};
